module.exports = __webpack_public_path__ + "static/img/jiaotong-5.50cb575.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/jiaotong/jiaotong-5.png
// module id = ksYP
// module chunks = 1